/* eslint-disable react-hooks/exhaustive-deps */
import DataHeaderDetail from "components/DataHeaderDetail/DataHeaderDetail";
import TimerIcon from "icons/TimerIcon";
import { useEffect } from "react";
import DialogAlert from "components/DialogAlert/v2";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { CloseButton } from "components/ToastMessage/styles";
import CampusListView from "views/Configuracion/components/CampusListView/CampusListView";
import RegisterSchedule from "../components/RegisterSchedule/RegisterSchedule";
import useFilters from "../components/RegisterSchedule/components/Filters/utils/hooks/useFilters";
import useRegisterScheduleData from "../utils/hooks/useRegisterScheduleData";
import useSettingsResourceScheduleAdminContext from "../context/useSettingsResourceScheduleAdminContext";
import { Container } from "./styles";

const ScheduleAdminGeneralCoordinator = () => {
	const { loadingRequest, data } = useSettingsResourceScheduleAdminContext();
	//#region States
	//#endregion
	const dialogForm = useShowDialogAlert();
	const filters = useFilters({
		uniqueCampus: false,
		data
	});
	const registerScheduleData = useRegisterScheduleData({
        loadingRequest, filters
    });
	//#region Effects
	useEffect(() => {
        if (dialogForm.value) 
			return;
		registerScheduleData.clear();
		filters.clear();
    }, [dialogForm.value]);
	//#endregion
	//#region Functions
	function openForm(campusId) {
		filters.setCampusId(campusId);
		dialogForm.open();
	}
	//#endregion
	return (
		<>
			<CampusListView
                campusList={data.campusList}
                onCampus={openForm}>
                <DataHeaderDetail
                    icon={<TimerIcon />}
                    text="Administrador de Horarios"
                    width="300px" />
            </CampusListView>
			<DialogAlert dialog={dialogForm} zIndex={1300}>
				<CloseButton onClick={dialogForm.hide}/>
				<Container className="custom-scrollbar secondary">
					<RegisterSchedule 
						filters={filters}
						registerScheduleData={registerScheduleData}
						cancelAction={dialogForm.hide} />
				</Container>
			</DialogAlert>
		</>
	);
}

export default ScheduleAdminGeneralCoordinator;